/* tslint:disable */
/* eslint-disable */
/**
 * TurboClaim API
 * TurboClaim API for insurance claim management. Includes claims, documents, estimates, supplements, billing, and chat operations. Authentication is JWT-based bearer token. 
 *
 * The version of the OpenAPI document: 1.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { SupplementJustification } from './SupplementJustification';
import {
    SupplementJustificationFromJSON,
    SupplementJustificationFromJSONTyped,
    SupplementJustificationToJSON,
    SupplementJustificationToJSONTyped,
} from './SupplementJustification';

/**
 * 
 * @export
 * @interface GetSupplementJustifications200Response
 */
export interface GetSupplementJustifications200Response {
    /**
     * 
     * @type {Array<SupplementJustification>}
     * @memberof GetSupplementJustifications200Response
     */
    items: Array<SupplementJustification>;
    /**
     * Total number of justifications
     * @type {number}
     * @memberof GetSupplementJustifications200Response
     */
    total: number;
    /**
     * Current page number
     * @type {number}
     * @memberof GetSupplementJustifications200Response
     */
    page: number;
    /**
     * Items per page
     * @type {number}
     * @memberof GetSupplementJustifications200Response
     */
    limit: number;
    /**
     * Whether there are more pages
     * @type {boolean}
     * @memberof GetSupplementJustifications200Response
     */
    hasMore: boolean;
}

/**
 * Check if a given object implements the GetSupplementJustifications200Response interface.
 */
export function instanceOfGetSupplementJustifications200Response(value: object): value is GetSupplementJustifications200Response {
    if (!('items' in value) || value['items'] === undefined) return false;
    if (!('total' in value) || value['total'] === undefined) return false;
    if (!('page' in value) || value['page'] === undefined) return false;
    if (!('limit' in value) || value['limit'] === undefined) return false;
    if (!('hasMore' in value) || value['hasMore'] === undefined) return false;
    return true;
}

export function GetSupplementJustifications200ResponseFromJSON(json: any): GetSupplementJustifications200Response {
    return GetSupplementJustifications200ResponseFromJSONTyped(json, false);
}

export function GetSupplementJustifications200ResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetSupplementJustifications200Response {
    if (json == null) {
        return json;
    }
    return {
        
        'items': ((json['items'] as Array<any>).map(SupplementJustificationFromJSON)),
        'total': json['total'],
        'page': json['page'],
        'limit': json['limit'],
        'hasMore': json['hasMore'],
    };
}

export function GetSupplementJustifications200ResponseToJSON(json: any): GetSupplementJustifications200Response {
    return GetSupplementJustifications200ResponseToJSONTyped(json, false);
}

export function GetSupplementJustifications200ResponseToJSONTyped(value?: GetSupplementJustifications200Response | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'items': ((value['items'] as Array<any>).map(SupplementJustificationToJSON)),
        'total': value['total'],
        'page': value['page'],
        'limit': value['limit'],
        'hasMore': value['hasMore'],
    };
}

